import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Highlightable} from '@angular/cdk/a11y';
import {BoAutocompleteOption} from '../model/BoAutocompleteOption';

@Component({
  selector: 'app-autocomplete-option',
  templateUrl: './autocomplete-option.component.html',
  styleUrls: ['./autocomplete-option.component.scss']
})
export class AutocompleteOptionComponent implements Highlightable {

  @Input() option: BoAutocompleteOption;
  @Output() autoCompleteOptionClicked = new EventEmitter<BoAutocompleteOption>();

  active = false;

  setActiveStyles(): void {
    this.active = true;
  }

  setInactiveStyles(): void {
    this.active = false;
  }

  emitAutoCompleteOptionClicked(option: BoAutocompleteOption) {
    this.autoCompleteOptionClicked.emit(option);
  }
}
